import React, {useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import root from 'window-or-global';

interface Props {
    children?: React.ReactNode;
}

export const ScrollToTop = ({children}: Props): JSX.Element => {
    const {pathname} = useLocation();
    const [prevPathname, setPrevPathname] = useState('');

    const mounted = useRef<boolean>();
    useEffect(() => {
        if (!mounted.current) {
            // componentDidMount
            mounted.current = true;
        } else {
            // componentDidUpdate
            if (prevPathname !== pathname) {
                setPrevPathname(pathname);
                root.scrollTo(0, 0);
            }
        }
    }, [prevPathname, pathname]);

    return <>{children}</>;
};
